<template>
  <div class="WelcomeView">
    <ApplicationWelcome />
  </div>
</template>

<script>
import ApplicationWelcome from '@/components/application/ApplicationWelcome.vue'

export default {
  name: 'WelcomeView',
  components: {
    ApplicationWelcome
  },
  beforeCreate() {
    //RA: Ensure application is forcibly set to null, to force a reload when user resumes or
    // starts a new application. Data is kept consistent between the application in vue store.   
    this.$store.commit('set', ['application', null])
    // reset resumeViaEmail and resumeViaButton flag
    this.$store.commit('set', ['resumeViaEmail', false])
    this.$store.commit('set', ['resumeViaButton', false])
  }
}
</script>

<style lang="scss">
@include desktop {
  .WelcomeView {
    width: 100%;
    height: 100%;
    min-height: 610px;
    text-align: left;
  }
}
</style>
